import { Show } from "solid-js";
import { createQuery } from "@tanstack/solid-query";
import { KpiCard } from "./ui/index";

interface KpiResponse {
  ok: boolean;
  hosts?: { total: number; online: number };
  sessions?: { active: number };
  operators?: { total: number; admins: number; superAdmins: number };
  bugReports?: { open: number; critical: number };
  tenants?: number;
  clients?: number;
  plugins?: { total: number; groups: number };
}

async function jget<T>(url: string): Promise<T> {
  const r = await fetch(url, { credentials: "include" });
  if (!r.ok) throw new Error(`${url} → ${r.status}`);
  return r.json() as Promise<T>;
}

export function SuperAdminDashboardPage() {
  const kpiQ = createQuery<KpiResponse>(() => ({
    queryKey: ["super-admin-kpi"],
    queryFn: () => jget<KpiResponse>("/api/super-admin/kpi"),
    refetchInterval: 15_000,
  }));

  const kpi = () => kpiQ.data;

  return (
    <div class="plugins-console" style={{ overflow: "auto" }}>
      <div class="plugins-console-header">
        <span class="plugins-console-title">
          Super Admin Dashboard
          <span class="plugins-console-sub">vue d'ensemble plateforme</span>
        </span>
      </div>

      <Show when={kpiQ.error}>
        <div class="bug-report-message" data-kind="err" style={{ "margin-bottom": "10px" }}>
          {kpiQ.error instanceof Error ? kpiQ.error.message : String(kpiQ.error)}
        </div>
      </Show>

      <div class="kpi-grid">
        <KpiCard label="Tenants" value={String(kpi()?.tenants ?? "—")} level="ok" />
        <KpiCard
          label="Hosts"
          value={`${kpi()?.hosts?.online ?? 0} / ${kpi()?.hosts?.total ?? 0}`}
          sub="en ligne"
          level={kpi()?.hosts?.online ? "ok" : "warn"}
        />
        <KpiCard label="Sessions actives" value={String(kpi()?.sessions?.active ?? "—")} level="ok" />
        <KpiCard
          label="Opérateurs"
          value={`${kpi()?.operators?.total ?? 0} (${kpi()?.operators?.superAdmins ?? 0} super)`}
          level="ok"
        />
        <KpiCard
          label="Signalements"
          value={`${kpi()?.bugReports?.open ?? 0} ouverts`}
          sub={kpi()?.bugReports?.critical ? `${kpi()?.bugReports?.critical} critique(s)` : undefined}
          level={kpi()?.bugReports?.critical ? "danger" : kpi()?.bugReports?.open ? "warn" : "ok"}
        />
        <KpiCard
          label="Plugins"
          value={`${kpi()?.plugins?.total ?? 0} / ${kpi()?.plugins?.groups ?? 0} groupes`}
          level="ok"
        />
        <KpiCard label="Clients MSP" value={String(kpi()?.clients ?? "—")} level="ok" />
      </div>
    </div>
  );
}
